<template lang="pug">
v-dialog(v-model="dialog" max-width="600")
  v-card
    v-card-title Add New Product
    v-card-text
      v-row
        v-col(label="Name")
          v-select(v-model="form.vertical" label="Vertical" :items="verticals")
        v-col(cols="12")
          v-text-field(v-model="form.original_title" label="Title")
    v-card-actions
      v-btn(block large tile color="primary" @click="add") Add
</template>

<script>
export default {
  name: "NewProductDialog",
  props: ['value'],
  data: (vm) => ({
    dialog: vm.value,
    verticals: [
      { text: 'Joined Tour', value: 'JT'},
      { text: 'Private Tour', value: 'PT'},
      { text: 'Short Tour', value: 'ST'},
      { text: 'Tickets', value: 'TIX'},
      { text: 'Activities', value: 'XTVT'},
      { text: 'Transport', value: 'TPORT'},
      { text: 'Visa', value: 'VISA'},
      { text: 'Travel Products', value: 'TP'}
    ],
    providers: [
      { text: 'ARBA Travel', value: 'ARBA'},
      { text: 'Cebu Travel', value: 'CBTV'},
      { text: 'Global Tix', value: 'GBTX'},
      { text: 'Klook', value: 'KLOK'},
      { text: 'Nanta', value: 'NNTA'},
      { text: 'Onvacay', value: 'ONVC'},
      { text: 'PlaceM', value: 'PLCM'},
      { text: 'TCRT', value: 'TCRT'},
      { text: 'BeMyGuest', value: 'BMGS'},
      { text: 'Marketplace API', value: 'MPLC'},
      { text: '-', value: '-'},
    ],
    form: {
      vertical: null,
      rating: 5.0,
      original_title: '',
      phase: 'draft'
    }
  }),
  watch: {
    value (val) {
      this.dialog = val
    },
    dialog (val) {
      this.$emit('input', val)
    },
    product (val) {
      this.form.product = val.id
    }
  },
  methods: {
    add () {
      this.$axios.post('/products/', this.form)
        .then(resp => {
          this.$emit('added', resp.data)
          this.dialog = false
          this.$showAlert('success', 'New product added!')
        })
        .catch(e => {
          this.$showAlert('error', 'Error adding product!')
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>